import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { SEATS_HELP_TEXT } from "@components/table/members/assign-seats/invite-seats-utils";
import { SeatCheckbox } from "@components/table/members/assign-seats/seat-checkbox";
import { CheckboxGroup } from "@flat-ui";
import { Stack } from "@mui-wrapper";
/**
 * The seats to give the people invited to the workspace, shown as the same seat cards that the
 * seats of a member are managed with. Checking a seat tells how many of the free seats the people
 * invited take. Nothing is shown while the workspace offers no seat the current user may assign.
 */
export function InviteSeatsSection(t0) {
  const $ = _c(20);
  const {
    inviteSeats,
    invitesCount,
    error,
    isDisabled
  } = t0;
  const {
    seatOptions,
    seatsAvailable,
    checkedSeats,
    isXgSeatRequired,
    setSeatChecked
  } = inviteSeats;
  if (!seatOptions.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LabelWithHelp title="Seats" help={SEATS_HELP_TEXT} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 1
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== checkedSeats || $[3] !== invitesCount || $[4] !== isDisabled || $[5] !== isXgSeatRequired || $[6] !== seatOptions || $[7] !== seatsAvailable || $[8] !== setSeatChecked) {
    let t4;
    if ($[10] !== checkedSeats || $[11] !== invitesCount || $[12] !== isDisabled || $[13] !== isXgSeatRequired || $[14] !== seatsAvailable || $[15] !== setSeatChecked) {
      t4 = option => <SeatCheckbox key={option.seat} option={option} isChecked={checkedSeats.includes(option.seat)} seatsAvailable={seatsAvailable[option.seat]} seatsUsed={Math.max(invitesCount, 1)} isDisabled={isDisabled || option.seat === "xgSeat" && isXgSeatRequired} onChange={setSeatChecked} />;
      $[10] = checkedSeats;
      $[11] = invitesCount;
      $[12] = isDisabled;
      $[13] = isXgSeatRequired;
      $[14] = seatsAvailable;
      $[15] = setSeatChecked;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t3 = seatOptions.map(t4);
    $[2] = checkedSeats;
    $[3] = invitesCount;
    $[4] = isDisabled;
    $[5] = isXgSeatRequired;
    $[6] = seatOptions;
    $[7] = seatsAvailable;
    $[8] = setSeatChecked;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[17] !== error || $[18] !== t3) {
    t4 = <Stack>{t1}<CheckboxGroup error={error} checkboxGroupSx={t2}>{t3}</CheckboxGroup></Stack>;
    $[17] = error;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}